import { Key } from 'react';

export enum Paths {
  Login = '/login',
  Root = '/',
  Students = '/students',
  StudentDetail = '/students/:studentId',
  RatingSentencesEdit = '/ratings-editor',
}

export const toStudentDetail = (studentId: string | Key): string => {
  const id = typeof studentId === 'string' ? studentId : studentId.toString();
  return Paths.StudentDetail.replace(':studentId', id);
};
